<template>
  <div id="Management">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" class="pt-5 px-5 mt-1">
      <div class="d-flex justify-space-between align-center">
        <h1>Gestão à vista</h1>
        <div class="mx-2">
          <timer />
        </div>
      </div>

      <v-tabs v-model="selectedTab" class="my-3">
        <v-tab> Transbordo </v-tab>
        <v-tab> Geral </v-tab>
      </v-tabs>
      <v-tabs-items v-model="selectedTab">
        <v-tab-item>
          <transhipment-management-tab :tab="selectedTab" class="pb-8 pt-2" />
        </v-tab-item>

        <v-tab-item>
          <general-management-tab :tab="selectedTab" class="pb-8 pt-2" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import BreadCrumb from '../../../components/BreadCrumb.vue';
import GeneralManagementTab from '@/components/Management/GeneralManagementTab';
import TranshipmentManagementTab from '@/components/Management/TranshipmentManagementTab';
import Timer from '@/components/Management/ManagementTimer.vue';
export default {
  name: 'Management',
  components: {
    BreadCrumb,
    GeneralManagementTab,
    TranshipmentManagementTab,
    Timer
  },
  data: () => ({
    selectedTab: 0,

    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Embarques',
        disabled: false,
        to: '/shipments',
        exact: true
      },
      {
        text: 'Gestão a Vista',
        disabled: true
      }
    ]
  }),

  computed: {},

  methods: {}
};
</script>
<style lang="scss" scoped>
::v-deep .v-pagination.v-pagination {
  justify-content: start;
  position: inherit;
  width: auto;
}
</style>
